import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class BrowseService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
  private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  browseProducts(catalogServiceUrl) {
    let headers = new HttpHeaders();
    headers = headers.append('Site', 'AppMarketPlace');
    headers = headers.append('channel', 'premier');
    headers = headers.append('portal', 'appmarket');
    return this.httpClientService.get(catalogServiceUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      })
      ,catchError( this.handleError ));
  }
    createPageLoadProperties() {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_BROWSE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SHOP;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';     
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  handleError = (error) => {
    return throwError(error);
  }
}
